import React from 'react';
import ReactDom from 'react-dom';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
import App from './layouts/App.jsx';
import AuthService from './utils/AuthService';
import './stylesheets/index.css';
import Splash from './pages/Splash.jsx';
import Admin from './admin/Admin.jsx';
import Home from './pages/Home.jsx';
import SignInPage from './pages/SignInPage.jsx';
import GeneratorContainer from './containers/GeneratorContainer.jsx';
import FontsContainer from './containers/FontsContainer.jsx';
import NotFound from './pages/NotFound.jsx';
import ShadowsContainer from './pages/projects/shadows/ShadowsContainer.jsx';
import Shadows from './pages/projects/shadows/Shadows.jsx';
import ShadowsAbout from './pages/projects/shadows/ShadowsAbout.jsx';
import ChromaticContainer from './pages/projects/chromatic/ChromaticContainer.jsx';
import Chromatic from './pages/projects/chromatic/Chromatic.jsx';
import CreateChromatic from './pages/projects/chromatic/CreateChromatic.jsx';
import ScreensaverContainer from './pages/projects/screensaver/ScreensaverContainer.jsx';
import throttle from 'lodash/throttle';

// Google Analytics
var ReactGA = require('react-ga');
ReactGA.initialize('UA-100615670-1');
function logPageView() {
  ReactGA.set({ page: window.location.pathname + window.location.search });
  ReactGA.pageview(window.location.pathname + window.location.search);
}

// Auth0
const auth = new AuthService('Nnf7EmolBHOxGu3W8Qi2kio3OR7vz71p', 'mixfont.auth0.com');
const requireAuth = (nextState, replace) => {
  if (!auth.loggedIn()) {
    replace({
      pathname: '/signin',
    });
    localStorage.setItem('nextPath', nextState.location.pathname);
  }
}

const parseAuthHash = (nextState, replace) => {
  if (/access_token|id_token|error/.test(nextState.location.hash)) {
    auth.parseHash(nextState.location.hash)
  }
}

const requireSignedOut = (nextState, replace) => {
  parseAuthHash(nextState, replace);

  if (auth.loggedIn()) {
    replace({
      pathname: '/home',
    });
  }
}

// Redux
import { Provider } from 'react-redux';
import store from './store/store';
import { saveState } from './store/localStorage';

store.subscribe(throttle(() => {
  // console.log(store.getState())
  const preservedState = store.getState();
  saveState({
    fonts: preservedState.fonts,
  });
}, 1000));

const rootEl = document.getElementById('root');

function handleUpdate() {
  logPageView();
  let {
    action
  } = this.state.location;
  if (action === 'PUSH') {
    window.scrollTo(0, 0);
  }
}

ReactDom.render((
  <Provider store={store}>
    <Router history={browserHistory} onUpdate={handleUpdate}>
      <Route path="/" component={App} auth={auth}>
        <IndexRoute component={Splash} />
        <Route path="/generate" component={GeneratorContainer} />
        <Route path="/admin" component={Admin} />
        <Route path="/home" component={Home} onEnter={requireAuth} />
        <Route path="/shadows" component={ShadowsContainer}>
          <IndexRoute component={Shadows} />
          <Route path="about" component={ShadowsAbout} />
        </Route>
        <Route path="/chromatic" component={ChromaticContainer}>
          <IndexRoute component={Chromatic} />
          <Route path="create" component={CreateChromatic} />
        </Route>
        <Route path="/screensaver" component={ScreensaverContainer} />
        <Route path="/404" component={NotFound} />
        <Route path="/signin" component={SignInPage} onEnter={requireSignedOut} />
        <Route path="/:primary+:secondary" component={FontsContainer} />
        <Route path="*" component={NotFound} />
      </Route>
    </Router>
  </Provider>
), rootEl);

if (module.hot) {
  module.hot.accept('./layouts/App.jsx', () => {
    const NextApp = require('./layouts/App.jsx').default;
    ReactDom.render(
      <NextApp />,
      rootEl
    );
  });
}



// WEBPACK FOOTER //
// ./src/index.js